export var SituacaoEnum;
(function (SituacaoEnum) {
    SituacaoEnum["ATIVO"] = "ATIVO";
    SituacaoEnum["INATIVO"] = "INATIVO";
})(SituacaoEnum || (SituacaoEnum = {}));
